var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 123,
    viewBox: "0 0 120 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "#DBE0E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_563_1079)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_563_1079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z",
    fill: "url(#paint0_linear_563_1079)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_563_1079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0729 28H21.9271C19.4821 28 17.5 29.9855 17.5 32.4348V125.565C17.5 128.014 19.4821 130 21.9271 130H98.0729C100.518 130 102.5 128.014 102.5 125.565V32.4348C102.5 29.9855 100.518 28 98.0729 28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.875 37H29.125C27.6753 37 26.5 38.1193 26.5 39.5C26.5 40.8807 27.6753 42 29.125 42H51.875C53.3247 42 54.5 40.8807 54.5 39.5C54.5 38.1193 53.3247 37 51.875 37Z",
    fill: "#D7E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.875 74H29.125C27.6753 74 26.5 75.2312 26.5 76.75C26.5 78.2688 27.6753 79.5 29.125 79.5H51.875C53.3247 79.5 54.5 78.2688 54.5 76.75C54.5 75.2312 53.3247 74 51.875 74Z",
    fill: "#D7E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0921 46.5H30.9079C28.4735 46.5 26.5 48.4898 26.5 50.9444V58.0556C26.5 60.5102 28.4735 62.5 30.9079 62.5H89.0921C91.5265 62.5 93.5 60.5102 93.5 58.0556V50.9444C93.5 48.4898 91.5265 46.5 89.0921 46.5Z",
    fill: "#D7E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.003 107.398L70.8672 78.6084L65.0979 84.447L94.2337 113.237L100.003 107.398Z",
    fill: "#D7E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.133 115.135L88.4648 92.7358C88.3386 92.6111 88.1352 92.6123 88.0105 92.7385L79.4309 101.421C79.3062 101.547 79.3074 101.751 79.4337 101.875L102.101 124.274C102.228 124.399 102.431 124.398 102.556 124.272L111.135 115.589C111.26 115.463 111.259 115.259 111.133 115.135Z",
    fill: "#17274F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3378 56.7939C78.3378 75.1816 63.4316 90.0878 45.0439 90.0878C26.6562 90.0878 11.75 75.1816 11.75 56.7939C11.75 38.4062 26.6562 23.5 45.0439 23.5C63.4316 23.5 78.3378 38.4062 78.3378 56.7939Z",
    stroke: "#17274F",
    strokeWidth: 6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_563_1079",
    x: 2.75,
    y: 11.5,
    width: 114.478,
    height: 111.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_563_1079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_563_1079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_563_1079",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.480874da3b69a64b6292a41b044adb0f.svg";
export { ForwardRef as ReactComponent };